export default __webpack_public_path__ + "static/media/Elite-black.fd9d5242.png";